import { type Optional, typeUtils } from '@festina-life/core'

import {
  isModelMetaType,
  type MetaModel,
  type ModelMetaType,
} from '../../types/metaModel'
import type { CreateTemplateDraftInput } from './types'

export const getTemplateType = (forTypeName: string, metaModel: MetaModel) => {
  const metaModelType = metaModel.types.get(forTypeName)
  const fallBackType: Optional<ModelMetaType> = isModelMetaType(metaModelType)
    ? metaModelType
    : undefined

  return fallBackType?.templateType ?? fallBackType
}

export const validateKey = typeUtils.createValidator<CreateTemplateDraftInput>()
